import Selectr from 'Selectr';
import axios from 'axios';
import { createElementFromHTML } from '../../utilities/js/helper';
import './media-center.scss';

class MediaCenter {
    constructor ($mediaCenter, options) {

        const settings = {};

        this.settings = Object.assign({}, settings, options);

        this.$mediaCenter = $mediaCenter;
        this.$mediaCenterForm = this.$mediaCenter.querySelector('[data-media-center="form"]');
        this.$mediaCenterFilter = this.$mediaCenter.querySelector('[data-media-center="filter"]');
        this.$mediaCenterSorting = this.$mediaCenter.querySelector('[data-media-center="sorting"]');
        this.$mediaCenterResults = this.$mediaCenter.querySelector('[data-media-center="results"]');
        this.$newPager = null;

        // Set filter button
        this.$button = this.$mediaCenterFilter.querySelector('.media-filter-button .button');

        // Select
        this.$$selects = this.$mediaCenterForm.querySelectorAll('.select');

        // Reset filter
        this.$resetLink = this.$mediaCenterFilter.querySelector('[data-filter-reset]');

        // Pager
        this.$pager = this.$mediaCenter.querySelector('[data-pager]');

        // Unfiltered count
        this.unfilteredCount = this.$mediaCenter.querySelector('[data-media-count]')?.innerHTML;
        this.$filteredResultCount = 0;
    }

    initialize () {
        this.initFilter();

        if (this.$mediaCenterSorting) {
            this.initSorting();
        }

        this.setFilterButtonValue();
        this.setEvents();
    }

    initFilter () {
        const $$selects = this.$mediaCenterFilter.querySelectorAll('select');

        if ($$selects.length > 0) {
            $$selects.forEach(($select, i) => {
                const $selectLabel = $select.dataset.label;
                const $selectPlaceholder = $select.dataset.placeholder;

                const $selectr = new Selectr($select, {
                    searchable: false,
                    clearable: false,
                    defaultSelected: false,
                    placeholder: $selectPlaceholder
                });

                if ($selectr.container) {
                    const $selectorElement = $selectr.container.querySelector('.selectr-selected');
                    const $selectorOptions = $selectr.container.querySelector('.selectr-options');

                    $selectr.container.onkeydown = (e) => {
                        if (e.code === 'Enter' || e.code === 'Space') {
                            e.preventDefault();
                        }
                    };

                    // close on out tab
                    document.addEventListener('keydown', (event) => {
                        if (event.code === 'Tab' || event.code === 'Tabs') {
                            if (!$selectr.container.contains(event.target) && $selectr.container.classList.contains('open')) {
                                setTimeout(() => {
                                    $selectr.opened = false;
                                    $selectr.container.classList.remove('open');

                                    if ($selectorElement) {
                                        $selectorElement.setAttribute('aria-expanded', 'false');
                                    }

                                    if ($selectorOptions) {
                                        $selectorOptions.removeAttribute('aria-expanded');
                                        $selectorOptions.setAttribute('tabindex', '-1');
                                    }
                                }, 300);
                            }
                        }
                    });

                    if ($selectorElement) {
                        $selectorElement.setAttribute('role', 'combobox');
                        $selectorElement.setAttribute('aria-label', `${$selectLabel} ${$selectPlaceholder}`); // eslint-disable-line
                        $selectorElement.setAttribute('aria-controls', `selector-options-${i}`); // eslint-disable-line
                    }

                    if ($selectorOptions) {
                        $selectorOptions.setAttribute('id', `selector-options-${i}`); // eslint-disable-line

                        $selectr.on('selectr.open', () => {
                            setTimeout(() => {
                                $selectorOptions.removeAttribute('aria-expanded');
                                $selectorOptions.setAttribute('tabindex', '0');

                                const $$selectOptionLabels = $selectorOptions.querySelectorAll('.selectr-optgroup--label');
                                if ($$selectOptionLabels.length > 0) {
                                    $$selectOptionLabels.forEach($optionLabel => {
                                        $optionLabel.setAttribute('role', 'presentation');
                                    });
                                }

                            }, 300);
                        });

                        $selectr.on('selectr.close', () => {
                            setTimeout(() => {
                                $selectorOptions.removeAttribute('aria-expanded');
                                $selectorOptions.setAttribute('tabindex', '-1');
                            }, 300);
                        });
                    }

                    $selectr.on('selectr.change', () => {
                        setTimeout(() => {
                            const $$selectOptionRemove = $selectorElement.querySelectorAll('.selectr-tag-remove');

                            if ($$selectOptionRemove.length > 0) {
                                $$selectOptionRemove.forEach($optionRemove => {
                                    $optionRemove.setAttribute('aria-label', `${$optionRemove.parentElement.innerText} ${window.translations.filter.remove_label}`); // eslint-disable-line
                                });
                            }
                        }, 300);
                    });
                }
            });
        }
    }

    initSorting () {
        const $$selects = this.$mediaCenterSorting.querySelectorAll('select');
        for (let i = 0; i < $$selects.length; i++) {
            const $select = $$selects[i];

            const $selectLabel = $select.dataset.label;
            const $selectPlaceholder = $select.dataset.placeholder;

            this.selectSorting = new Selectr($select, { // eslint-disable-line
                searchable: false,
                clearable: false,
                defaultSelected: true,
                placeholder: $select.getAttribute('placeholder')
            });

            if (this.selectSorting.container) {
                const $selectorElement = this.selectSorting.container.querySelector('.selectr-selected');
                const $selectorOptions = this.selectSorting.container.querySelector('.selectr-options');

                this.selectSorting.container.onkeydown = (e) => {
                    if (e.code === 'Enter' || e.code === 'Space') {
                        e.preventDefault();
                    }
                };

                // close on out tab
                document.addEventListener('keydown', (event) => {
                    if (event.code === 'Tab' || event.code === 'Tabs') {
                        if (!this.selectSorting.container.contains(event.target) && this.selectSorting.container.classList.contains('open')) {
                            setTimeout(() => {
                                this.selectSorting.opened = false;
                                this.selectSorting.container.classList.remove('open');

                                if ($selectorElement) {
                                    $selectorElement.setAttribute('aria-expanded', 'false');
                                }

                                if ($selectorOptions) {
                                    $selectorOptions.removeAttribute('aria-expanded');
                                    $selectorOptions.setAttribute('tabindex', '-1');
                                }
                            }, 300);
                        }
                    }
                });

                if ($selectorElement) {
                    $selectorElement.setAttribute('role', 'combobox');
                    $selectorElement.setAttribute('aria-label', `${$selectLabel} ${$selectPlaceholder}`); // eslint-disable-line
                    $selectorElement.setAttribute('aria-controls', `selector-sorting-options-${i}`); // eslint-disable-line
                }

                if ($selectorOptions) {
                    $selectorOptions.setAttribute('id', `selector-sorting-options-${i}`); // eslint-disable-line

                    this.selectSorting.on('selectr.open', () => {
                        setTimeout(() => {
                            $selectorOptions.removeAttribute('aria-expanded');
                            $selectorOptions.setAttribute('tabindex', '0');
                        }, 300);
                    });

                    this.selectSorting.on('selectr.close', () => {
                        setTimeout(() => {
                            $selectorOptions.removeAttribute('aria-expanded');
                            $selectorOptions.setAttribute('tabindex', '-1');
                        }, 300);
                    });
                }
            }
        }
    }

    // FUNCTION – Set filter button value
    setFilterButtonValue (count) {
        const value = this.$button.getAttribute('data-filter-value');
        if (count) {
            this.$button.setAttribute('value', value + count);
        } else {
            this.$button.setAttribute('value', value);
        }
    }

    // FUNCTION – change filter button state
    setFilterButton (resultsCount, selectedTagsCount) {
        if (selectedTagsCount > 0 && resultsCount > 0) {
            this.setFilterButtonValue(' (' + resultsCount + ')');
            this.$button.removeAttribute('disabled');
        } else if (selectedTagsCount > 0 && resultsCount < 1) {
            this.setFilterButtonValue(' (' + resultsCount + ')');
            this.$button.setAttribute('disabled', 'disabled');
        } else {
            this.setFilterButtonValue();
            this.$button.classList.add('is--inactive');
            this.$button.setAttribute('disabled', 'disabled');
        }
    }

    // FUNCTION – Update Pager
    updatePager () {
        const pager = this.$mediaCenterResults.querySelector('[data-pager]');

        if (pager) {
            this.$mediaCenterResults.removeChild(pager.parentNode);
        }

        if (this.$newPager !== null) {
            this.$mediaCenterResults.appendChild(this.$newPager);

            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$newPager
                }
            });

            window.dispatchEvent(contentUpdateEvent);
        }
    }

    // FUNCTION – Update list of teaser
    updateList () {
        this.$mediaCenterResults.querySelector('.teaser-grid__items').innerHTML = '';
        if (this.$filteredResult.innerHTML) {
            this.$mediaCenterResults.querySelector('.teaser-grid__items').appendChild(this.$filteredResult);            
            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$filteredResult
                }
            });

            window.dispatchEvent(contentUpdateEvent);
        } else {
            const pseudoResultWrapper = document.createElement('div');
            this.$filteredResult.forEach(element => {
                pseudoResultWrapper.appendChild(element);
            });

            const contentUpdateEvent = new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: pseudoResultWrapper
                }
            });

            window.dispatchEvent(contentUpdateEvent);

            this.$filteredResult.forEach(element => {
                this.$mediaCenterResults.querySelector('.teaser-grid__items').appendChild(element);
            });
        }
    }

    // FUNCTION – reset filter to initial state
    resetFilter (e) {
        this.$resetLink.parentElement.classList.remove('is--visible');

        setTimeout(() => {
            this.updateResults(e, true);
        }, 500);
    }

    // FUNCTION – update result list
    updateResults (e, reset = false) {
        e.preventDefault();

        if (reset === false) {
            this.$resetLink.parentElement.classList.add('is--visible');
        }

        this.updateList();
        this.updatePager();
        this.setCount(reset ? this.unfilteredCount : this.$filteredResultCount);
    }

    // FUNCTION – set count
    setCount (value) {
        const counter = this.$mediaCenter.querySelector('[data-media-count]');

        if (counter) {
            counter.innerHTML = value;
        }
    }

    // FUNCTION –  update list by sorting
    updateSorting () {
        this.updateList();
        this.updatePager();
    }

    // AJAX – for filtering and sorting
    updateFilter (e) {
        const formMethod = this.$mediaCenterForm.getAttribute('method');
        const formAction = this.$mediaCenterForm.getAttribute('action');
        const formData = new FormData(this.$mediaCenterForm);
        let filteredResultsCount = 0;

        axios({
            method: formMethod,
            url: formAction,
            data: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((result) => {
                const ajaxResult = JSON.parse(result.request.responseText);
                this.selectedTagsCount = this.$mediaCenterFilter.querySelectorAll('.select option[selected]').length;
                filteredResultsCount = ajaxResult.count;
                this.$filteredResult = createElementFromHTML(ajaxResult.list);
                this.$filteredResultCount = ajaxResult.count;
                                
                if (ajaxResult.pager) {
                    this.$newPager = createElementFromHTML(ajaxResult.pager);
                }

                // Update filter state
                this.setFilterButton(filteredResultsCount, this.selectedTagsCount);

                // Update sorting
                if (this.$mediaCenterSorting) {
                    if (e.target.getAttribute('name') == 'sorting') {
                        this.updateSorting();
                    }
                }

            })
            .catch((error) => {
                throw Error(error);
            });
    }

    // EVENTS
    setEvents () {
        this.$resetLink.addEventListener('click', (e) => {
            this.resetFilter(e);
        });

        this.$mediaCenterForm.addEventListener('submit', (e) => {
            this.updateResults(e);
        });

        this.$mediaCenterForm.addEventListener('change', (e) => {
            this.updateFilter(e);
        });
    }
}

export { MediaCenter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-media-center="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new MediaCenter($root);
            $rootAPI.initialize();
        });
    }
});
